module.exports = __webpack_public_path__ + "img/fig08.9e5a1842.jpg";